<template>
  <div>
    <div class="staffMesgbox">
      <div class="flexbetween paddingtb1 borderbottom">
        <div class="textfont">店员手机</div>
        <input class="staffinput" v-model="phone" placeholder="请输入店员手机号" />
      </div>
      <div class="flexbetween paddingtb1 borderbottom">
        <div class="textfont">店员密码</div>
        <input class="staffinput" v-model="password" placeholder="请输入店员密码" />
      </div>
      <div class="flexbetween paddingtb1">
        <div class="textfont">备注</div>
        <input class="staffinput" v-model="remarks" placeholder="请输入店员备注" />
      </div>
    </div>
    <div class="addbotton1" @click="addStaff">新增</div>
  </div>
</template>

<script>
  import httper from '../../../api/http';
  var phone_mreg = /^1[2-9][0-9]{9}$/;
  export default {
    data() {
      return {
        phone: "",
        password: "",
        remarks: "",
        edit: 0
      }
    },
    created() {
      if (parseInt(this.$route.params.edit) != 0) {
        this.edit = parseInt(this.$route.params.edit)
        if (this.$route.params.staffMesg) {
          let staffMesg = JSON.parse(this.$route.params.staffMesg)
          console.log("staffMesg", staffMesg)
          this.phone = staffMesg.mobile
          this.password = staffMesg.password
          this.remarks = staffMesg.name
        }
      }
    },
    mounted() {

    },
    methods: {
      addStaff(){
        let that = this
        let requestData = {}
        console.log(phone_mreg.test(that.phone))
        if(!phone_mreg.test(that.phone)){
          that.$toast({
            message: '请输入正确的手机号码',
          })
          return
        }
        if(!that.password){
          that.$toast({
            message: '请输入密码',
          })
          return
        }
        requestData.mobile = this.phone
        requestData.password = this.password
        requestData.name = this.remarks
        that.request("addstaff",requestData)
      },
      // 调用接口
      request(type = '', requestData = {}) {
        let that = this
        switch (type) {
          //新增店员
          case 'addstaff':
            httper.post('store/add-admin', requestData, function(res) {
              if (res.code === 0) {
                that.$toast({
                  message: '添加成功',
                })
                that.$router.push({
                  path: '/staffList'
                })
              } else {
                that.$toast({
                  message: res.message || '操作失败',
                });
              }
            }, true)
            break
            //编辑店员
            case '':
              httper.post('', requestData, function(res) {
                if (res.code === 0) {

                } else {
                  that.$toast({
                    message: res.message || '操作失败',
                  });
                }
              }, true)
              break
        }
      },
    }
  }
</script>

<style scoped="scoped">
  .staffMesgbox {
    width: calc(100% - 20px);
    margin: 10px;
    padding: 20px;
    box-sizing: border-box;
    background-color: #FFFFFF;
    border-radius: 8px;
  }
input{
  text-align: end;
}
  input::-webkit-input-placeholder {
    text-align: end;
  }
</style>



// WEBPACK FOOTER //
// src/pages/store/addStaff.vue